import React, { useState, useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import classNames from 'classnames';
import { CHeader } from './c/CHeader';
import CDrawer from './CDrawer';
import CHeaderBarContent from './CHeaderBarContent';
import FeedbackModel from '../../Feedback/FeedbackModel';
import ExamSelectionModel from "../../ExamSelectionModel/ExamSelectionModel";
import { saveFeedbackForm } from 'examsbook-react-sdk/actions/saveFeedback';
import { useSelector, useDispatch } from 'react-redux';
import { withStyles } from "@material-ui/core";
import { useScreenWidth } from "examsbook-react-sdk/custom-hooks";
import { useLocation } from "react-router-dom";

const drawerWidth = 240;

/**
 * Main Header component.
 */

function Header(props) {
    const [ isFeedbackModelOpen, setIsFeedbackModelOpen ] = useState(false);
    const [ addHeaderExamModal, setAddHeaderExamModal ] = useState(false);
    const { classes, open, handleDrawerClose, handleDrawerOpen } = props;
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const location = useLocation();
    const screenWidth = useScreenWidth();

    function openFeedbackModel() {
        setIsFeedbackModelOpen(true);
    }

    function closeFeedBackModel() {
        setIsFeedbackModelOpen(false);
    }

    function submitFeedbackForm(message) {
        dispatch(saveFeedbackForm({ message: message }));
        closeFeedBackModel();
    }

    function closeExamModel() {
        setAddHeaderExamModal(!addHeaderExamModal);
    }

    useEffect(() => {
        if (user && user.selectedExams &&
            (user.selectedExams.length === 0 || (user.selectedExams.length > 0 && !user.selectedExam))) {
            setAddHeaderExamModal(true);
        }
    }, [ user ]);

    return (
        <React.Fragment>
            {
                !(location && location.pathname && location.pathname.includes('my-app/quiz/')) ?
                    <CHeader classes={classes}>
                        <CssBaseline/>
                        <div className="header-bar">
                            <CHeaderBarContent classes={classes}
                                               open={open}
                                               handleDrawerOpen={handleDrawerOpen}
                                               handleAddHeaderExam={closeExamModel}
                                               openFeedbackModel={openFeedbackModel}/>
                        </div>
                        {screenWidth > 900 && screenWidth < 1024 ?
                            <CDrawer handleDrawerClose={handleDrawerClose}
                                     open={!open}
                                     classes={classes}
                                     openFeedbackModel={openFeedbackModel}/> :
                            <CDrawer handleDrawerClose={handleDrawerClose}
                                     open={open}
                                     classes={classes}
                                     openFeedbackModel={openFeedbackModel}/>}
                        <main className={classNames(classes.content, {
                            [classes.contentShift]: open,
                        })}>
                            <div className={classes.drawerHeader}/>
                        </main>
                        <FeedbackModel
                            isFeedbackModelOpen={isFeedbackModelOpen}
                            closeFeedBackModel={closeFeedBackModel}
                            submitForm={submitFeedbackForm}/>
                        <ExamSelectionModel classes={classes} closeExamModel={closeExamModel}
                                            addHeaderExamModal={addHeaderExamModal}/>
                    </CHeader> : ''
            }
        </React.Fragment>
    );
}

const styles = theme => ({
    root: {
        display: 'flex',
    },
    paper: {
        position: 'absolute',
        width: theme.spacing(1) * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '16px 32px',
        outline: 'none',
    },
    appBar: {
        backgroundColor: '#2962ff',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create([ 'width', 'margin' ], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `100%`,
        transition: theme.transitions.create([ 'margin', 'width' ], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        position: 'fixed',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        '@media (max-width: 767px)': {
            width: '80%'
        }
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(1) * 7,
        '@media (max-width: 1024px)': {
            width: '0',
            zIndex: '1202'
        },
        [theme.breakpoints.up('lg')]: {
            width: '56px',
            zIndex: '1200'
        },

    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0',
        minHeight: 66,
        position: 'relative',
        justifyContent: 'flex-end',
        top: 66,
        [theme.breakpoints.down('sm')]: {
            backgroundColor: '#fff',
            top: 0,
            minHeight: 54
        },
    },
    content: {},
    contentShift: {

        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
        padding: 0
    },
    menuButtonHidden: {
        display: 'none',
    },
    HeaderMenuButton: {
        float: 'left',
        '@media (max-width: 767px)': {
            color: '#2962ff',
            '& svg': {
                fontSize: 30,
                color: '#757575'
            }
        }
    }
});

export default withStyles(styles, { withTheme: true })(Header);
